import { useEffect } from "react";

export default function SEO({ title, description, image, type = "website", jsonLd, canonical, robots = "index,follow" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | GKDeals` : "GKDeals — Deals, Coupons & Product Reviews";
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "robots", robots);
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    if (image) {
      const abs = image.startsWith("http") ? image : `${window.location.origin}${image}`;
      setMeta("property", "og:image", abs);
      setMeta("name", "twitter:image", abs);
    }
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);

    const href = canonical || window.location.href.split("#")[0].split("?")[0];
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);
    setMeta("property", "og:url", href);

    // support one object OR an array of JSON-LD blocks
    const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
    document.head.querySelectorAll('script[data-seo-ld="1"]').forEach((n) => n.remove());
    blocks.forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-ld", "1");
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, image, type, jsonLd, canonical, robots]);

  return null;
}
